import $ from 'jquery';
const axios = require('axios').default;
var store = require('store');

export default() => {
    ((Shipping, $) => {
        'use strict';

        Shipping.location = store.get('location') ? store.get('location') : null;
        Shipping.getLocation = async () => {
            return await axios.get('https://api.ipstack.com/check?access_key=ba1a35f985d082e35cdf6736a4c32280')
                .then(function (response) {
                    Shipping.setLocation(response.data.country_code);
                    return response.data
                })
                .catch(function (error) {
                    console.log(error);
                    return error;
                });
        };
        Shipping.setLocation = (location) => {
            Shipping.location = location;
            store.set('location', location)
        };
        Shipping.update = () => {
            console.log(Shipping.location)
            if (Shipping.location === null) {
                Shipping.getLocation();
            }
        };
        Shipping.Promo = () => {
            let total = parseInt(CartJS.cart.total_price),
                amount = parseInt(document.querySelector('[data-needed-amount]').dataset.neededAmount),
                needed = amount - total;
            if (needed > 0) {
                document.querySelector('[data-needed-text]').style.display = "block";
                document.querySelector('[data-unlock-text]').style.display = "none";
                document.querySelector('[data-needed-text]').querySelector('span').innerText = parseInt(needed/ 100);
                let percent = (total / amount) * 100;
                document.querySelector('.shipping__needed').style.width = `${percent}%`
            }
            else {
                document.querySelector('[data-needed-text]').style.display = "none";
                document.querySelector('[data-unlock-text]').style.display = "block";
                document.querySelector('.shipping__needed').style.width = '100%'
            }
        }

    })(window.Shipping = window.Shipping || {}, $);
}
